import { createFileRoute } from "@tanstack/react-router";
import { DocumentsTable } from "@/modules/patients/documents/table";

export const Route = createFileRoute("/dashboard/patients/$patientId/documents")({
	component: RouteComponent,
});

function RouteComponent() {
	const { patientId } = Route.useParams();

	return (
		<div className="space-y-6">
			<div className="">
				<DocumentsTable patientId={patientId} />
			</div>
		</div>
	);
}
